module.exports = __webpack_public_path__ + "static/img/fish36.7501bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish36.png
// module id = 1Ysb
// module chunks = 0